module.exports = __webpack_public_path__ + "img/36_11.e9bb5239.png";